import { startMove } from './move';

/** The address move (game/move.ts), done before anything else in the game reads its storage: imported first. */
export const moveState = startMove();
